import CheckCircle from '@mui/icons-material/CheckCircle'
import CloseRounded from '@mui/icons-material/CloseRounded'
import FormatQuote from '@mui/icons-material/FormatQuote'
import HighlightOffTwoTone from '@mui/icons-material/HighlightOffTwoTone'
import { ButtonBase, DialogContent, IconButton } from '@mui/material'
import styled from 'styled-components'

export const BusinessPaywallContent = styled(DialogContent)`
  position: relative;
  text-align: center;
  font-family: 'Outfit';
  background: ${({ theme, themeType }) => theme?.[themeType]?.paywallBackground};
  ::-webkit-scrollbar {
    width: 5px;
    background: rgba(255, 255, 255, 0.2);
  }

  ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.2);
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #613ccd;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #613ccd;
  }
`
export const BusinessPaywallCloseIcon = styled(HighlightOffTwoTone)`
  color: ${({ theme, themeType }) => (themeType === 'dark' ? '#fff' : '#ABABAB')};
  color: ${({ theme, themeType }) => (themeType === 'dark' ? '#fff' : '#ABABAB')};
  font-size: 40px !important;
`
export const BusinessPaywallCloseButton = styled(IconButton)`
  flex-shrink: 0 !important;
  padding: 5px !important;
`
export const BusinessPaywallCloseButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  top: 30px;
  z-index: 9999;
  padding: 0px 10px;
  position: sticky;
  height: 0px;
`

export const BusinessPaywallContentContainer = styled.div`
  padding: 50px 24px 20px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  @media (min-width: 768) {
    gap: 20px;
  }
`
export const PaywallTrialHeading = styled.div`
  color: ${({ theme, themeType }) => theme?.[themeType]?.paywallTrialHeadingColor};
  font-size: 32px;
  font-weight: 600;
  @media (min-width: 576px) {
    font-size: 32px;
  }
  @media (min-width: 992px) {
    font-size: 45px;
  }
`
export const PaywallTrialHeadingHighlight = styled.span`
  color: ${({ theme, themeType }) => theme?.[themeType]?.paywallTrialHeadingHighlightColor};
`
export const PaywallTrialSubHeading = styled.div`
  color: ${({ theme, themeType }) => theme?.[themeType]?.paywallTrialSubheadingColor};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  @media (min-width: 992px) {
    font-size: 20px;
  }
`
export const PaywallTrialFeatuersContainer = styled.div`
  width: 95%;
  border-radius: 20px;
  flex-shrink: 0;
  background: ${({ themeType, theme }) => theme?.[themeType]?.paywallTrialBackground};
  padding: 10px;
  padding-bottom: 30px;
  @media (min-width: 768px) {
    padding: 26px;
  }
`
export const PaywallTrialButton = styled(ButtonBase)`
  border-radius: 37px !important;
  color: ${({ theme, themeType }) => theme?.[themeType]?.paywallTrialButtonTextColor} !important;
  background: ${({ theme, themeType }) => theme?.[themeType]?.paywallTrialButtonColor} !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  padding: 10px 20px !important;
  @media (min-width: 576px) {
    padding: 10px 55px !important;
    font-size: 21px;
  }
  @media (min-width: 992px) {
    padding: 12px 40px !important;
    font-size: 20px;
  }
  @media (min-width: 1400px) {
    padding: 15px 61px !important;
    font-size: 24px;
  }
`

export const PaywallFeatureTable = styled.div`
  background: transparent;
  color: #fff;
  width: 100%;
`
export const PaywallFeatureTableRow = styled.div`
  display: grid;
  grid-template-columns: 40% 30% 30%;
  border-radius: 9px;
  height: 60px;
  align-items: center;
  border: none;
  ${({ header }) => header && 'font-size: 20px; font-style: normal; font-weight: 700;'}
  background: transparent;
  &:nth-child(even) {
    background: #9062f4;
    ${({ header }) => header && 'height: 60px;'}
  }
`
export const PaywallFeatureTableData = styled.div``

export const PaywallCheckIcon = styled(CheckCircle)`
  color: #4cff2f;
`
export const PaywallPlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 19px;
  padding: 20px 0px 40px 0px;
  @media (min-width: 992px) {
    gap: 40px;
    padding: 20px 0px 50px 0px;
  }
`
export const PaywallPlanHeading = styled.div`
  color: ${({ theme, themeType }) => theme?.[themeType]?.paywallPlansHeadingColor};
  font-style: normal;
  font-weight: 600;
  font-size: 35px;
  @media (min-width: 576px) {
    font-size: 40px;
  }
`
export const PaywallPlanCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding: 20px 30px;
  ${'' /* min-height: 300px; */}
  border-radius: 20px;
  background: ${({ theme, themeType, recommended }) =>
    recommended
      ? theme?.[themeType]?.paywallPlanCardBackgroundMain
      : theme?.[themeType]?.paywallPlanCardBackgroundSecondary};
  ${({ themeType }) =>
    themeType === 'light' && 'box-shadow: 0px 22px 24px 0px rgba(213, 207, 177, 0.33);'}
  width: 350px;
  @media (min-width: 576px) {
    padding: 25px 32px;
  }
  @media (min-width: 992px) {
    width: 280px;
  }
`

export const PaywallPlansContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    display: none;
  }
  @media (min-width: 576px) {
    align-items: center;
  }
  @media (min-width: 992px) {
    align-items: stretch;
    flex-direction: row;
  }
  @media (min-width: 1400px) {
    overflow-x: scroll;
    justify-content: center;
  }
`

export const PaywallPlanRecommendedText = styled.div`
  font-size: 15px;
  color: #fff;
`
export const PaywallPlanRecommendedTextPlaceholder = styled.div`
  height: 22.5px;
  color: #fff;
`
export const PaywallPlanName = styled.div`
  font-style: normal;
  text-wrap: nowrap;
  font-weight: 600;
  font-size: 21px;
  min-height: 20px;
  color: #fff;
`

export const PaywallPlanSubtext = styled.div`
  text-align: center;
  opacity: 0.4;
  color: #fff;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  min-height: 30px;
  @media (min-width: 992px) {
    min-height: 100px;
  }
`
export const PlanPriceText = styled.div`
  font-size: 45px;
  color: #fff;
  font-weight: 300;
  letter-spacing: -2px;
  > .plan-price-per-person {
    font-size: 18px;
    letter-spacing: 0px;
  }
  ${
    '' /* @media (min-width: 992px) {
    font-size: 60px;
  } */
  }
`

export const PlanMainDetailsContainer = styled.div`
  position: sticky;
  top: 0px;
  @media (min-width: 992px) {
    min-height: 300px;
  }
`

export const PaywallFeatureListContainer = styled.div`
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-top: 0px;
  flex-grow: 1;
  display: none;
  @media (min-width: 992px) {
    display: flex;
  }
`

export const PaywallPlanFeatureListItem = styled.div`
  text-align: start;
  font-size: 11px;
  font-weight: 400;
  display: flex;
  justify-content: start;
  gap: 12px;
`
export const PaywallGetTrialButtonPrimary = styled(ButtonBase)`
  border-radius: 26px !important;
  padding: 10px 30px !important;
  background: #f9f2ff !important;
  color: #7047c5 !important;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  align-self: center !important;
  @media (min-width: 992px) {
    padding: 8px 19px !important;
  }
`
export const TestimonialsContainer = styled.div`
  background: #111111;
  display: none;
  padding: 69px 0px;
  @media (min-width: 768px) {
    display: block;
  }
`
export const TestimonialsHeading = styled.div`
  color: #fff;
  font-size: 40px;
  font-weight: 600;
  @media (min-width: 992px) {
    font-size: 50px;
    margin-bottom: 40px;
  }
`
export const TestimoinalContainer = styled.div`
  position: relative;
  background: ${({ type }) => (type === 'hero' ? '#ffffffe5' : '#FFFFFF5E')};
  width: 291px;
  height: 380px;
  margin-top: 90px;
  border-radius: 6px;
  color: ${({ type }) => (type === 'hero' ? '#000' : '#fff')};
  box-shadow: 26px 28px 31px 0px rgba(0, 0, 0, 0.61);
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 26px 35px;
  padding-top: ${({ type }) => (type === 'hero' ? '85px' : '55px')} !important;
  @media (min-width: 992px) {
    margin-top: 60px;
    width: 335px;
    height: 400px;
  }
  @media (min-width: 1400px) {
    width: ${({ type }) => (type === 'hero' ? '456px' : '334px')} !important;
    height: ${({ type }) => (type === 'hero' ? '494px' : '362px')} !important;
  }
`
export const TestimonialText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  flex-grow: 1;
  font-size: 19px;
  font-weight: 400;
  @media (min-width: 768px) {
    font-size: 20px;
  }
  @media (min-width: 1400px) {
    font-size: ${({ type }) => (type === 'hero' ? '28px' : '19px')};
  }
`
export const TestimonialsCardsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  padding: 0px 30px;
  gap: 40px;
  @media (min-width: 768px) {
    align-items: center;
  }
  @media (min-width: 992px) {
    align-items: center;
  }
  @media (min-width: 1400px) {
    align-items: center;
    justify-content: center;
  }
`
export const TestimonialDivider = styled.hr`
  background: ${({ type }) => (type === 'hero' ? '#818181' : '#D3D3D3')} !important;
  height: 2px !important;
  border-radius: 30px;
  width: 50%;
`
export const TestimoinalUser = styled.div`
  color: ${({ type }) => (type === 'hero' ? '#818181' : '#D3D3D3')} !important;
  font-size: ${({ type }) => (type === 'hero' ? '19px' : '16px')};
`
export const TestimonialProfileImage = styled.img`
  width: 110px;
  height: 110px;
  top: -55px;
  position: absolute;
  object-fit: cover;
  border-radius: 100%;
  @media (min-width: 768px) {
    width: 120px;
    height: 120px;
    top: -60px;
  }
  @media (min-width: 1400px) {
    top: ${({ type }) => (type === 'hero' ? '-75px' : '-45px')} !important;
    width: ${({ type }) => (type === 'hero' ? '150px' : '90px')} !important;
    height: ${({ type }) => (type === 'hero' ? '150px' : '90px')} !important;
  }
`
export const TestimonialQuoteIcon = styled(FormatQuote)`
  transform: rotate(180deg) !important;
  font-size: 50px !important;
  @media (min-width: 1400px) {
    font-size: ${({ type }) => (type === 'hero' ? '90px' : '50px')} !important;
  }
`
